import React, { useEffect } from 'react';

// eslint-disable-next-line no-restricted-imports -- Initial import for FullScreenLoader
import { FullScreenLoader as BricksFullScreenLoader } from '@opendoor/bricks/core';

import { useTOSContext } from './TOSProvider';

/**
 * FullScreenLoader - use this instead of directly importing from bricks to hide the TOS modal on load
 *
 * storybook-check-ignore
 */
export const FullScreenLoader: React.FC<{
  /** @deprecated - not used anymore */
  from?: string;
  /** @deprecated - not used anymore */
  reason?: string;
}> = () => {
  const { forceHideTOSModal } = useTOSContext();

  // DO NOT REMOVE: Do not show the TOS modal on this page
  useEffect(() => {
    // set this as false on the initial render - so it doesn't show it on this page
    forceHideTOSModal(true);
    return () => {
      // allow the TOS component to be shown when we unmount
      forceHideTOSModal(false);
    };
  }, [forceHideTOSModal]);

  return <BricksFullScreenLoader />;
};
